const STORE_CLIENT_KEY = `${'certexam'}-store-client`;

function persistFlag(): void {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('store') === '1' || params.get('app') === '1') {
      localStorage.setItem(STORE_CLIENT_KEY, '1');
    }
  } catch {
    // localStorage peut être indisponible (mode privé strict).
  }
}

/**
 * True quand l'UI tourne dans une coque store (Play / App Store) :
 * WebView Android, WKWebView iOS, Capacitor, TWA (`android-app://`),
 * ou flag `?store=1` posé par le wrapper natif.
 *
 * Les navigateurs mobiles (Chrome, Safari) restent du « web » : le paiement
 * FlexPay y est autorisé. Les achats in-app store (Apple Pay / Play Billing)
 * ne sont volontairement pas proposés.
 */
export function isStoreClient(): boolean {
  if (typeof window === 'undefined') return false;
  persistFlag();

  try {
    if (localStorage.getItem(STORE_CLIENT_KEY) === '1') return true;
  } catch {
    /* ignore */
  }

  const w = window as Window & {
    Capacitor?: unknown;
    ReactNativeWebView?: unknown;
  };
  if (w.Capacitor || w.ReactNativeWebView) return true;

  const referrer = document.referrer || '';
  if (referrer.startsWith('android-app://')) return true;

  const ua = navigator.userAgent || '';
  if (/; wv\)/.test(ua) || /Version\/[\d.]+ Chrome\/[\d.]+ Mobile/.test(ua) && /wv/.test(ua)) {
    return true;
  }
  if (/\bwv\b/.test(ua)) return true;
  if (/iPhone|iPod|iPad/i.test(ua) && /AppleWebKit/i.test(ua) && !/Safari/i.test(ua)) {
    return true;
  }

  return false;
}

export const WEB_SUBSCRIBE_HOST = 'exam-copilot.com';
